var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e7) { throw _e7; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e8) { didErr = true; err = _e8; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (t) {
  "function" == typeof define && define.amd ? define(t) : t();
}(function () {
  "use strict";

  function t() {}

  var e = function e(t) {
    return t;
  };

  function n(t) {
    return t();
  }

  function o() {
    return Object.create(null);
  }

  function r(t) {
    t.forEach(n);
  }

  function _i(t) {
    return "function" == typeof t;
  }

  function s(t, e) {
    return t != t ? e == e : t !== e;
  }

  var a = "undefined" != typeof window;
  var c = a ? function () {
    return window.performance.now();
  } : function () {
    return Date.now();
  },
      l = a ? function (t) {
    return requestAnimationFrame(t);
  } : t;
  var u = new Set();

  function d(t) {
    u.forEach(function (e) {
      e.c(t) || (u.delete(e), e.f());
    }), 0 !== u.size && l(d);
  }

  function f(t) {
    var e;
    return 0 === u.size && l(d), {
      promise: new Promise(function (n) {
        u.add(e = {
          c: t,
          f: n
        });
      }),
      abort: function abort() {
        u.delete(e);
      }
    };
  }

  function h(t, e) {
    t.appendChild(e);
  }

  function m(t) {
    if (!t) return document;
    var e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
    return e && e.host ? e : t.ownerDocument;
  }

  function $(t) {
    var e = v("style");
    return function (t, e) {
      h(t.head || t, e);
    }(m(t), e), e;
  }

  function g(t, e, n) {
    t.insertBefore(e, n || null);
  }

  function p(t) {
    t.parentNode.removeChild(t);
  }

  function v(t) {
    return document.createElement(t);
  }

  function w() {
    return t = " ", document.createTextNode(t);
    var t;
  }

  function b(t, e, n, o) {
    return t.addEventListener(e, n, o), function () {
      return t.removeEventListener(e, n, o);
    };
  }

  function x(t, e, n) {
    null == n ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n);
  }

  function y(t, e, n, o) {
    t.style.setProperty(e, n, o ? "important" : "");
  }

  function _(t) {
    var e = {};

    var _iterator = _createForOfIteratorHelper(t),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _n = _step.value;
        e[_n.name] = _n.value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return e;
  }

  var k = new Set();
  var E,
      C = 0;

  function D(t, e, n, o, r, i, s) {
    var a = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var c = 16.666 / o;
    var l = "{\n";

    for (var _t = 0; _t <= 1; _t += c) {
      var _o = e + (n - e) * i(_t);

      l += 100 * _t + "%{".concat(s(_o, 1 - _o), "}\n");
    }

    var u = l + "100% {".concat(s(n, 1 - n), "}\n}"),
        d = "__svelte_".concat(function (t) {
      var e = 5381,
          n = t.length;

      for (; n--;) {
        e = (e << 5) - e ^ t.charCodeAt(n);
      }

      return e >>> 0;
    }(u), "_").concat(a),
        f = m(t);
    k.add(f);
    var h = f.__svelte_stylesheet || (f.__svelte_stylesheet = $(t).sheet),
        g = f.__svelte_rules || (f.__svelte_rules = {});
    g[d] || (g[d] = !0, h.insertRule("@keyframes ".concat(d, " ").concat(u), h.cssRules.length));
    var p = t.style.animation || "";
    return t.style.animation = "".concat(p ? "".concat(p, ", ") : "").concat(d, " ").concat(o, "ms linear ").concat(r, "ms 1 both"), C += 1, d;
  }

  function z(t, e) {
    var n = (t.style.animation || "").split(", "),
        o = n.filter(e ? function (t) {
      return t.indexOf(e) < 0;
    } : function (t) {
      return -1 === t.indexOf("__svelte");
    }),
        r = n.length - o.length;
    r && (t.style.animation = o.join(", "), C -= r, C || l(function () {
      C || (k.forEach(function (t) {
        var e = t.__svelte_stylesheet;
        var n = e.cssRules.length;

        for (; n--;) {
          e.deleteRule(n);
        }

        t.__svelte_rules = {};
      }), k.clear());
    }));
  }

  function A(t) {
    E = t;
  }

  var S = [],
      R = [],
      T = [],
      L = [],
      O = Promise.resolve();
  var P = !1;

  function M(t) {
    T.push(t);
  }

  var N = !1;
  var j = new Set();

  function H() {
    if (!N) {
      N = !0;

      do {
        for (var _t2 = 0; _t2 < S.length; _t2 += 1) {
          var _e = S[_t2];
          A(_e), q(_e.$$);
        }

        for (A(null), S.length = 0; R.length;) {
          R.pop()();
        }

        for (var _t3 = 0; _t3 < T.length; _t3 += 1) {
          var _e2 = T[_t3];
          j.has(_e2) || (j.add(_e2), _e2());
        }

        T.length = 0;
      } while (S.length);

      for (; L.length;) {
        L.pop()();
      }

      P = !1, N = !1, j.clear();
    }
  }

  function q(t) {
    if (null !== t.fragment) {
      t.update(), r(t.before_update);
      var _e3 = t.dirty;
      t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, _e3), t.after_update.forEach(M);
    }
  }

  var B;

  function F() {
    return B || (B = Promise.resolve(), B.then(function () {
      B = null;
    })), B;
  }

  function G(t, e, n) {
    t.dispatchEvent(function (t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var o = document.createEvent("CustomEvent");
      return o.initCustomEvent(t, n, !1, e), o;
    }("".concat(e ? "intro" : "outro").concat(n)));
  }

  var I = new Set();
  var J;

  function K(t, e) {
    t && t.i && (I.delete(t), t.i(e));
  }

  function Q(t, e, n, o) {
    if (t && t.o) {
      if (I.has(t)) return;
      I.add(t), J.c.push(function () {
        I.delete(t), o && (n && t.d(1), o());
      }), t.o(e);
    }
  }

  var U = {
    duration: 0
  };

  function V(t, e) {
    -1 === t.$$.dirty[0] && (S.push(t), P || (P = !0, O.then(H)), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
  }

  function W(e, s, a, c, l, u, d) {
    var f = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [-1];
    var h = E;
    A(e);
    var m = e.$$ = {
      fragment: null,
      ctx: null,
      props: u,
      update: t,
      not_equal: l,
      bound: o(),
      on_mount: [],
      on_destroy: [],
      on_disconnect: [],
      before_update: [],
      after_update: [],
      context: new Map(s.context || (h ? h.$$.context : [])),
      callbacks: o(),
      dirty: f,
      skip_bound: !1,
      root: s.target || h.$$.root
    };
    d && d(m.root);
    var $ = !1;

    if (m.ctx = a ? a(e, s.props || {}, function (t, n) {
      var r = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : n;
      return m.ctx && l(m.ctx[t], m.ctx[t] = r) && (!m.skip_bound && m.bound[t] && m.bound[t](r), $ && V(e, t)), n;
    }) : [], m.update(), $ = !0, r(m.before_update), m.fragment = !!c && c(m.ctx), s.target) {
      if (s.hydrate) {
        var _t4 = function (t) {
          return Array.from(t.childNodes);
        }(s.target);

        m.fragment && m.fragment.l(_t4), _t4.forEach(p);
      } else m.fragment && m.fragment.c();

      s.intro && K(e.$$.fragment), function (t, e, o, s) {
        var _t$$$ = t.$$,
            a = _t$$$.fragment,
            c = _t$$$.on_mount,
            l = _t$$$.on_destroy,
            u = _t$$$.after_update;
        a && a.m(e, o), s || M(function () {
          var e = c.map(n).filter(_i);
          l ? l.push.apply(l, _toConsumableArray(e)) : r(e), t.$$.on_mount = [];
        }), u.forEach(M);
      }(e, s.target, s.anchor, s.customElement), H();
    }

    A(h);
  }

  var X;

  function Y(n) {
    var _o2,
        s,
        a,
        l,
        u,
        d,
        m,
        $,
        _,
        k,
        E = tt;

    return {
      c: function c() {
        _o2 = v("div"), s = v("div"), s.innerHTML = "<slot></slot>", a = w(), l = v("div"), u = w(), E && E.c(), x(s, "class", "CalloutDiv"), function (t, e, n) {
          t.classList[n ? "add" : "remove"](e);
        }(s, "useShadow", tt), x(l, "class", "ArrowDiv"), y(l, "--ax", n[3].x), y(l, "--ay", "100%"), x(_o2, "class", "CalloutContainerDiv"), y(_o2, "width", n[1]);
      },
      m: function m(t, e) {
        g(t, _o2, e), h(_o2, s), h(_o2, a), h(_o2, l), h(_o2, u), E && E.m(_o2, null), $ = !0, _ || (k = [b(_o2, "mousedown", n[7]), b(_o2, "touchstart", n[7]), b(_o2, "dragstart", n[7])], _ = !0);
      },
      p: function p(t, e) {
        (!$ || 8 & e) && y(l, "--ax", t[3].x), (!$ || 2 & e) && y(_o2, "width", t[1]);
      },
      i: function i(r) {
        $ || (M(function () {
          m && m.end(1), d = function (n, o, r) {
            var s,
                a,
                l = o(n, r),
                u = !1,
                d = 0;

            function h() {
              s && z(n, s);
            }

            function m() {
              var _ref = l || U,
                  _ref$delay = _ref.delay,
                  o = _ref$delay === void 0 ? 0 : _ref$delay,
                  _ref$duration = _ref.duration,
                  r = _ref$duration === void 0 ? 300 : _ref$duration,
                  _ref$easing = _ref.easing,
                  i = _ref$easing === void 0 ? e : _ref$easing,
                  _ref$tick = _ref.tick,
                  m = _ref$tick === void 0 ? t : _ref$tick,
                  $ = _ref.css;

              $ && (s = D(n, 0, 1, r, o, i, $, d++)), m(0, 1);
              var g = c() + o,
                  p = g + r;
              a && a.abort(), u = !0, M(function () {
                return G(n, !0, "start");
              }), a = f(function (t) {
                if (u) {
                  if (t >= p) return m(1, 0), G(n, !0, "end"), h(), u = !1;

                  if (t >= g) {
                    var _e4 = i((t - g) / r);

                    m(_e4, 1 - _e4);
                  }
                }

                return u;
              });
            }

            var $ = !1;
            return {
              start: function start() {
                $ || ($ = !0, z(n), _i(l) ? (l = l(), F().then(m)) : m());
              },
              invalidate: function invalidate() {
                $ = !1;
              },
              end: function end() {
                u && (h(), u = !1);
              }
            };
          }(_o2, n[6], {}), d.start();
        }), $ = !0);
      },
      o: function o(s) {
        d && d.invalidate(), m = function (n, o, s) {
          var a,
              l = o(n, s),
              u = !0;
          var d = J;

          function h() {
            var _ref2 = l || U,
                _ref2$delay = _ref2.delay,
                o = _ref2$delay === void 0 ? 0 : _ref2$delay,
                _ref2$duration = _ref2.duration,
                i = _ref2$duration === void 0 ? 300 : _ref2$duration,
                _ref2$easing = _ref2.easing,
                s = _ref2$easing === void 0 ? e : _ref2$easing,
                _ref2$tick = _ref2.tick,
                h = _ref2$tick === void 0 ? t : _ref2$tick,
                m = _ref2.css;

            m && (a = D(n, 1, 0, i, o, s, m));
            var $ = c() + o,
                g = $ + i;
            M(function () {
              return G(n, !1, "start");
            }), f(function (t) {
              if (u) {
                if (t >= g) return h(0, 1), G(n, !1, "end"), --d.r || r(d.c), !1;

                if (t >= $) {
                  var _e5 = s((t - $) / i);

                  h(1 - _e5, _e5);
                }
              }

              return u;
            });
          }

          return d.r += 1, _i(l) ? F().then(function () {
            l = l(), h();
          }) : h(), {
            end: function end(t) {
              t && l.tick && l.tick(1, 0), u && (a && z(n, a), u = !1);
            }
          };
        }(_o2, n[6], {}), $ = !1;
      },
      d: function d(t) {
        t && p(_o2), E && E.d(), t && m && m.end(), _ = !1, r(k);
      }
    };
  }

  function Z(e) {
    var n,
        _o3,
        _i2 = e[2] && Y(e);

    return {
      c: function c() {
        n = v("main"), _i2 && _i2.c(), this.c = t, y(n, "--ax", e[4].x), y(n, "--ay", e[4].y), y(n, "--halign", e[3].x), y(n, "--valign", e[3].y), y(n, "--borderradius", et), y(n, "--arrowpad", "".concat(e[5].value).concat(e[5].unit)), y(n, "--backgroundcolor", e[0]), y(n, "--size", "".concat(e[5].value * Math.sqrt(2)).concat(e[5].unit)), y(n, "--offsetx", "0rem"), y(n, "--offsety", "".concat(e[5].value).concat(e[5].unit));
      },
      m: function m(t, e) {
        g(t, n, e), _i2 && _i2.m(n, null), _o3 = !0;
      },
      p: function p(t, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            e = _ref4[0];

        t[2] ? _i2 ? (_i2.p(t, e), 4 & e && K(_i2, 1)) : (_i2 = Y(t), _i2.c(), K(_i2, 1), _i2.m(n, null)) : _i2 && (J = {
          r: 0,
          c: [],
          p: J
        }, Q(_i2, 1, 1, function () {
          _i2 = null;
        }), J.r || r(J.c), J = J.p), (!_o3 || 8 & e) && y(n, "--halign", t[3].x), (!_o3 || 8 & e) && y(n, "--valign", t[3].y), (!_o3 || 1 & e) && y(n, "--backgroundcolor", t[0]);
      },
      i: function i(t) {
        _o3 || (K(_i2), _o3 = !0);
      },
      o: function o(t) {
        Q(_i2), _o3 = !1;
      },
      d: function d(t) {
        t && p(n), _i2 && _i2.d();
      }
    };
  }

  "function" == typeof HTMLElement && (X = /*#__PURE__*/function (_HTMLElement) {
    _inherits(X, _HTMLElement);

    function X() {
      var _this;

      _classCallCheck(this, X);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(X).call(this)), _this.attachShadow({
        mode: "open"
      });
      return _this;
    }

    _createClass(X, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var t = this.$$.on_mount;
        this.$$.on_disconnect = t.map(n).filter(_i);

        for (var _t5 in this.$$.slotted) {
          this.appendChild(this.$$.slotted[_t5]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(t, e, n) {
        this[t] = n;
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        r(this.$$.on_disconnect);
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        !function (t, e) {
          var n = t.$$;
          null !== n.fragment && (r(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []);
        }(this, 1), this.$destroy = t;
      }
    }, {
      key: "$on",
      value: function $on(t, e) {
        var n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
        return n.push(e), function () {
          var t = n.indexOf(e);
          -1 !== t && n.splice(t, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set(t) {
        var e;
        this.$$set && (e = t, 0 !== Object.keys(e).length) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
      }
    }]);

    return X;
  }(_wrapNativeSuper(HTMLElement)));
  var tt = !1,
      et = "0rem";

  function nt(t, e, n) {
    var o,
        r = e.show,
        _e$showtime = e.showtime,
        i = _e$showtime === void 0 ? 1e4 : _e$showtime,
        _e$backgroundcolor = e.backgroundcolor,
        s = _e$backgroundcolor === void 0 ? "#202020" : _e$backgroundcolor,
        _e$xalign = e.xalign,
        a = _e$xalign === void 0 ? "50%" : _e$xalign,
        _e$width = e.width,
        c = _e$width === void 0 ? "auto" : _e$width,
        l = null,
        u = !1;
    var d = (f = function f(t, _ref5) {
      var _ref5$duration = _ref5.duration,
          e = _ref5$duration === void 0 ? 250 : _ref5$duration;
      return {
        duration: e,
        css: function css(t) {
          return "\n          clip-path: circle(".concat(100 * t, "% at ").concat(o.x, " 50%);\n        ");
        }
      };
    }, function (t, e) {
      if (!t.hasOwnProperty("ownerDocument")) {
        Object.defineProperty(t, "ownerDocument", {
          get: function get() {
            return t.parentElement;
          }
        });
        var _e6 = t;

        for (; _e6.parentElement;) {
          _e6 = _e6.parentElement;
        }

        t.parentElement.head = _e6;
      }

      return f(t, e);
    });
    var f;
    return t.$$set = function (t) {
      "show" in t && n(8, r = t.show), "showtime" in t && n(9, i = t.showtime), "backgroundcolor" in t && n(0, s = t.backgroundcolor), "xalign" in t && n(10, a = t.xalign), "width" in t && n(1, c = t.width);
    }, t.$$.update = function () {
      1024 & t.$$.dirty && n(3, o = {
        x: a,
        y: "100%"
      }), 256 & t.$$.dirty && function (t) {
        null !== l && (window.clearTimeout(l), l = null), void 0 !== t && "false" !== t ? l = window.setTimeout(function () {
          n(2, u = !0), l = null, i > 0 && (l = window.setTimeout(function () {
            n(2, u = !1), l = null;
          }, i));
        }, 500) : n(2, u = !1);
      }(r);
    }, [s, c, u, o, {
      x: "50%",
      y: "10%"
    }, {
      value: .55,
      unit: "rem"
    }, d, function (t) {
      t.preventDefault(), t.stopPropagation(), n(2, u = !1);
    }, r, i, a];
  }

  var ot = /*#__PURE__*/function (_X) {
    _inherits(ot, _X);

    function ot(t) {
      var _this2;

      _classCallCheck(this, ot);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ot).call(this)), _this2.shadowRoot.innerHTML = "<style>main{margin:0;padding:0}.CalloutContainerDiv{position:absolute;left:var(--ax);top:var(--ay);transform:translate(calc(-1 * var(--halign)), calc(-1 * var(--valign)));padding:var(--arrowpad);z-index:10;pointer-events:auto}.CalloutDiv{position:relative;box-sizing:border-box;min-width:8rem;border-radius:var(--borderradius);padding:0.50rem 1rem;background-color:var(--backgroundcolor);text-align:center;user-select:none;z-index:10}.useShadow{box-shadow:0 0.2rem 0.5rem #00000040}.ArrowDiv{position:absolute;left:calc(var(--ax) - var(--offsetx));top:calc(var(--ay) - var(--offsety));transform:translate(-50%, -50%) rotate(45deg);width:var(--size);height:var(--size);background-color:var(--backgroundcolor);z-index:10}.ArrowShadowDiv{position:absolute;left:calc(var(--ax) - var(--offsetx));top:calc(var(--ay) - var(--offsety));transform:translate(-50%, -50%) rotate(45deg);width:var(--size);height:var(--size);background-color:var(--backgroundcolor);background-color:#00000000;box-shadow:0 0.2rem 0.5rem #00000040;z-index:9}</style>", W(_assertThisInitialized(_assertThisInitialized(_this2)), {
        target: _this2.shadowRoot,
        props: _(_this2.attributes),
        customElement: !0
      }, nt, Z, s, {
        show: 8,
        showtime: 9,
        backgroundcolor: 0,
        xalign: 10,
        width: 1
      }, null), t && (t.target && g(t.target, _assertThisInitialized(_assertThisInitialized(_this2)), t.anchor), t.props && (_this2.$set(t.props), H()));
      return _this2;
    }

    _createClass(ot, [{
      key: "show",
      get: function get() {
        return this.$$.ctx[8];
      },
      set: function set(t) {
        this.$$set({
          show: t
        }), H();
      }
    }, {
      key: "showtime",
      get: function get() {
        return this.$$.ctx[9];
      },
      set: function set(t) {
        this.$$set({
          showtime: t
        }), H();
      }
    }, {
      key: "backgroundcolor",
      get: function get() {
        return this.$$.ctx[0];
      },
      set: function set(t) {
        this.$$set({
          backgroundcolor: t
        }), H();
      }
    }, {
      key: "xalign",
      get: function get() {
        return this.$$.ctx[10];
      },
      set: function set(t) {
        this.$$set({
          xalign: t
        }), H();
      }
    }, {
      key: "width",
      get: function get() {
        return this.$$.ctx[1];
      },
      set: function set(t) {
        this.$$set({
          width: t
        }), H();
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["show", "showtime", "backgroundcolor", "xalign", "width"];
      }
    }]);

    return ot;
  }(X);

  customElements.get("call-out") ? console.warn("Skipping re-defining customElement call-out") : customElements.define("call-out", ot);
});